import { FormattedMessage } from "react-intl";
import { Column } from "react-table";
import HighlightText from "../../../../Shared/HighlightText/HighlightText";
import TableColumnHeader from "../../../../Shared/Table/TableColumnHeader/TableColumnHeader";
import { LinkableUsersTableItem } from "./LinkableUsersTable";

export const linkableUsersTableColumns = (
  highlightText?: string
): Column<LinkableUsersTableItem>[] => [
  {
    accessor: "entity",
    Header: ({ column }) => (
      <TableColumnHeader
        sortable
        isSorted={column.isSorted}
        isSortedDesc={column.isSortedDesc}
      >
        <span className="capitalized">
          <FormattedMessage id="MANAGEMENT.ENTITY" defaultMessage="Entity" />
        </span>
      </TableColumnHeader>
    ),
    Cell: ({ row }) => (
      <HighlightText
        text={row.original?.entity ?? ""}
        highlightText={[highlightText ?? ""]}
      />
    ),
  },
  {
    accessor: "firstName",
    Header: ({ column }) => (
      <TableColumnHeader
        sortable
        isSorted={column.isSorted}
        isSortedDesc={column.isSortedDesc}
      >
        <span className="capitalized">
          <FormattedMessage id="USER.FIRST_NAME" defaultMessage="First Name" />
        </span>
      </TableColumnHeader>
    ),
    Cell: ({ row }) => (
      <HighlightText
        text={row.original?.firstName ?? ""}
        highlightText={[highlightText ?? ""]}
      />
    ),
  },
  {
    accessor: "lastName",
    Header: ({ column }) => (
      <TableColumnHeader
        sortable
        isSorted={column.isSorted}
        isSortedDesc={column.isSortedDesc}
      >
        <span className="capitalized">
          <FormattedMessage id="USER.LAST_NAME" defaultMessage="Last Name" />
        </span>
      </TableColumnHeader>
    ),
    Cell: ({ row }) => (
      <HighlightText
        text={row.original?.lastName ?? ""}
        highlightText={[highlightText ?? ""]}
      />
    ),
  },
  {
    accessor: "title",
    Header: ({ column }) => (
      <TableColumnHeader
        sortable
        isSorted={column.isSorted}
        isSortedDesc={column.isSortedDesc}
      >
        <span className="capitalized">
          <FormattedMessage id="USER.TITLE" defaultMessage="Title" />
        </span>
      </TableColumnHeader>
    ),
    Cell: ({ row }) => (
      <HighlightText
        text={row.original?.title ?? ""}
        highlightText={[highlightText ?? ""]}
      />
    ),
  },
  {
    accessor: "email",
    Header: ({ column }) => (
      <TableColumnHeader
        sortable
        isSorted={column.isSorted}
        isSortedDesc={column.isSortedDesc}
      >
        <span className="capitalized">
          <FormattedMessage id="USER.EMAIL" defaultMessage="Email" />
        </span>
      </TableColumnHeader>
    ),
    Cell: ({ row }) => (
      <HighlightText
        text={row.original?.email ?? ""}
        highlightText={[highlightText ?? ""]}
      />
    ),
  },
  {
    accessor: "phone",
    Header: ({ column }) => (
      <TableColumnHeader
        sortable
        isSorted={column.isSorted}
        isSortedDesc={column.isSortedDesc}
      >
        <span className="capitalized">
          <FormattedMessage id="USER.PHONE" defaultMessage="Phone" />
        </span>
      </TableColumnHeader>
    ),
    Cell: ({ row }) => (
      <HighlightText
        text={row.original?.phone ?? ""}
        highlightText={[highlightText ?? ""]}
      />
    ),
  },
];
